import React from "react";
import PropTypes from "prop-types";

import Loading from "../../../component/loading/Loading";
import { usePopularBrands } from "../../../query/usePopularBrands";

import "./SearchBrandRankings.scss";
import dayjs from "dayjs";
import CircleLetterLogo from "../../../component/circleLetterLogo/CircleLetterLogo";

/**
 * 브랜드 랭킹 리스트 (popular, trending, etc.).
 * @param {string} rankingType
 * @param handleOnBrandClick
 */
export default function SearchBrandRankings({
  rankingType = "popular",
  handleOnBrandClick,
}) {
  const { loading, data, error } = usePopularBrands(rankingType);

  let brands = [];
  if (!loading && !error && data) {
    if (
      rankingType === "popular" &&
      data &&
      data.getPopularKeywordsByFilterCached
    ) {
      brands = data.getPopularKeywordsByFilterCached.popularBrands || [];
    } else if (
      rankingType === "trending" &&
      data &&
      data.getPopularKeywordsByFilterCached
    ) {
      brands = data.getPopularKeywordsByFilterCached.trendingBrands || [];
    }
  }

  const displayBrands = brands;

  if (error) {
    return <></>;
  }

  const items = displayBrands.map((brand) => {
    return (
      <li
        key={`${rankingType}-${brand.name}`}
        className="SearchBrandRankings-item"
      >
        <div
          className="SearchBrandRankings-link"
          onClick={() => handleOnBrandClick(brand.name)}
        >
          <CircleLetterLogo
            logo={brand.resizedSmallLogo}
            size={52}
            name={brand.name}
          />
          <div className="SearchBrandRankings-info">
            <div className="SearchBrandRankings-name">{brand.name}</div>
            {brand.name_kr && (
              <div className="SearchBrandRankings-sub">{brand.name_kr}</div>
            )}
          </div>
        </div>
      </li>
    );
  });

  const now = new Date();
  const hour = dayjs(now).hour();

  return (
    <div className="SearchBrandRankings">
      <div className="SearchBrandRankings-header">
        <span className="SearchBrandRankings-title">
          {rankingType === "popular" ? "인기 브랜드" : "지금 뜨는 브랜드"}
        </span>
        <span className="SearchPopularKeyword-time">{`오늘 ${hour}시 기준`}</span>
      </div>
      {loading ? (
        <div className="SearchBrandRankings-loading">
          <Loading />
        </div>
      ) : (
        items.length > 0 && (
          <ul className="SearchBrandRankings-list">{items}</ul>
        )
      )}
    </div>
  );
}

SearchBrandRankings.propTypes = {
  rankingType: PropTypes.oneOf(["popular", "trending"]).isRequired,
  handleOnBrandClick: PropTypes.func,
};
